<template>
  <div :key="key" v-if="key > 0">
    <BaseCard width="600" class="mt-5">
      <div class="">
        <v-form ref="form" class="text-start d-grid gap-4">
          <BaseInput
            class="mb-4"
            :label="t['group-extra-work-code']"
            v-model="data.groupCode"
            :view-value="data.groupCode || '-'"
            v-bind="presetBaseInput"
          />
          <BaseInput
            :label="t['group-extra-work-name']"
            v-model="data.groupName"
            :view-value="data.groupName || '-'"
            v-bind="presetBaseInput"
          />
        </v-form>
      </div>
    </BaseCard>
    <div class="d-flex flex-wrap align-baseline gap mt-5">
      <BaseCard width="600">
        <BaseInput
          type="autocomplete"
          :label="t['fin-system']"
          v-model="data.finSystem"
          :items="finSystemList"
          :view-value="finSystemList.filter(i => i.id === data.finSystem)[0] && finSystemList.filter(i => i.id === data.finSystem)[0].name || ''"
          v-bind="presetBaseInput"
        />
      </BaseCard>
      <BaseCard v-if="data.finSystem === 'heeros'" width="600">
        <v-form ref="heeros" class="text-start d-grid gap-4">
          <BaseInput
            :label="t['username']"
            v-model="data.username"
            class="mb-4"
            v-bind="presetBaseInput"
          />
          <BaseInput
            :label="t['password']"
            v-model="data.password"
            class="mb-4"
            v-bind="presetBaseInput"
            :input-type="showPassword ? 'text' : 'password'"
          >
            <template slot="append-outer">
              <BaseButton
                icon_only
                minimalize
                :default_icon="showPassword ? 'button-show' : 'button-hide'"
                @click="showPassword = !showPassword"
              />
            </template>
            <template slot="viewValue">
              <div class="d-flex justify-space-between">
                <div v-if="showPassword">
                  {{ data.password }}
                </div>
                <div v-else>
                  <template v-for="l in data.password">
                    <span :key="l">•</span>
                  </template>
                </div>
                <BaseButton
                  icon_only
                  minimalize
                  :default_icon="showPassword ? 'button-show' : 'button-hide'"
                  @click="showPassword = !showPassword"
                />
              </div>
            </template>
          </BaseInput>
          <BaseInput
            :label="t['account_id']"
            v-model="data.accountId"
            v-bind="presetBaseInput"
            class="mb-4"
          />
          <BaseInput
            :label="t['customer_id']"
            v-model="data.customerId"
            v-bind="presetBaseInput"
          />
        </v-form>
      </BaseCard>
      <BaseCard v-else-if="data.finSystem === 'netvisor'" width="600">
        <v-form ref="netvisor" class="text-start d-grid gap-4">
          <BaseInput
            :label="t['customer_id']"
            v-model="data.netvisorCustomerId"
            v-bind="presetBaseInput"
          />
          <BaseInput
            :label="t['partner_id']"
            v-model="data.netvisorPartnerId"
            v-bind="presetBaseInput"
          />
          <BaseInput
            :label="t['organization_id']"
            v-model="data.netvisorOrganizationId"
            v-bind="presetBaseInput"
          />
          <BaseInput
            :label="t['user_key']"
            v-model="data.netvisorUserKey"
            v-bind="presetBaseInput"
            :input-type="showNetvisorUserKey ? 'text' : 'password'"
          >
            <template slot="append-outer">
              <BaseButton
                icon_only
                minimalize
                :default_icon="showNetvisorUserKey ? 'button-show' : 'button-hide'"
                @click="showNetvisorUserKey = !showNetvisorUserKey"
              />
            </template>
            <template slot="viewValue">
              <div class="d-flex justify-space-between">
                <div v-if="showNetvisorUserKey">
                  {{ data.netvisorUserKey }}
                </div>
                <div v-else>
                  <template v-for="(l, ll) in data.netvisorUserKey">
                    <span :key="ll">•</span>
                  </template>
                </div>
                <BaseButton
                  icon_only
                  minimalize
                  :default_icon="showNetvisorUserKey ? 'button-show' : 'button-hide'"
                  @click="showNetvisorUserKey = !showNetvisorUserKey"
                />
              </div>
            </template>
          </BaseInput>
          <BaseInput
            :label="t['partner_key']"
            v-model="data.netvisorPartnerKey"
            v-bind="presetBaseInput"
            :input-type="showNetvisorPartnerKey ? 'text' : 'password'"
          >
            <template slot="append-outer">
              <BaseButton
                icon_only
                minimalize
                :default_icon="showNetvisorPartnerKey ? 'button-show' : 'button-hide'"
                @click="showNetvisorPartnerKey = !showNetvisorPartnerKey"
              />
            </template>
            <template slot="viewValue">
              <div class="d-flex justify-space-between">
                <div v-if="showNetvisorPartnerKey">
                  {{ data.netvisorPartnerKey }}
                </div>
                <div v-else>
                  <template v-for="(k, kk) in data.netvisorPartnerKey">
                    <span :key="kk">•</span>
                  </template>
                </div>
                <BaseButton
                  icon_only
                  minimalize
                  :default_icon="showNetvisorPartnerKey ? 'button-show' : 'button-hide'"
                  @click="showNetvisorPartnerKey = !showNetvisorPartnerKey"
                />
              </div>
            </template>
          </BaseInput>
        </v-form>
      </BaseCard>
      <BaseCard v-else-if="data.finSystem === 'procountor'" width="600">
      <v-form ref="procountor" class="text-start d-grid gap-4">
       <BaseInput
        :label="t['client_id']"
        v-model="data.clientId"
        v-bind="presetBaseInput"
       />
       <BaseInput
        :label="t['client_secret_key']"
        v-model="data.clientSecret"
        v-bind="presetBaseInput"
        :input-type="showProcounterClientSecret ? 'text' : 'password'"
        class="text-break"
       >
        <template slot="append-outer">
         <BaseButton
          icon_only
          minimalize
          :default_icon="showProcounterClientSecret ? 'button-show' : 'button-hide'"
          @click="showProcounterClientSecret = !showProcounterClientSecret"
         />
        </template>
        <template slot="viewValue">
         <div class="d-flex justify-space-between">
          <div style="max-width: 500px" v-if="showProcounterClientSecret">
           {{ data.clientSecret }}
          </div>
          <div style="max-width: 500px" v-else>
           <template v-for="(l, ll) in data.clientSecret">
            <span :key="ll">•</span>
           </template>
          </div>
          <BaseButton
           icon_only
           minimalize
           :default_icon="showProcounterClientSecret ? 'button-show' : 'button-hide'"
           @click="showProcounterClientSecret = !showProcounterClientSecret"
          />
         </div>
        </template>
       </BaseInput>
       <BaseInput
        :label="t['client_api_key']"
        v-model="data.clientKey"
        v-bind="presetBaseInput"
        :input-type="showProcounterClientKey ? 'text' : 'password'"
        class="text-break"
       >
        <template slot="append-outer">
         <BaseButton
          icon_only
          minimalize
          :default_icon="showProcounterClientKey ? 'button-show' : 'button-hide'"
          @click="showProcounterClientKey = !showProcounterClientKey"
         />
        </template>
        <template slot="viewValue">
         <div class="d-flex justify-space-between">
          <div style="max-width: 500px" v-if="showProcounterClientKey">
           {{ data.clientKey }}
          </div>
          <div style="max-width: 500px" v-else>
           <template v-for="(k, kk) in data.clientKey">
            <span :key="kk">•</span>
           </template>
          </div>
          <BaseButton
           icon_only
           minimalize
           :default_icon="showProcounterClientKey ? 'button-show' : 'button-hide'"
           @click="showProcounterClientKey = !showProcounterClientKey"
          />
         </div>
        </template>
       </BaseInput>
      </v-form>
     </BaseCard>
    </div>
    <v-btn style="margin-top: 200px" icon @click="edit = !edit">.</v-btn>
    <v-dialog v-model="dialog" width="1400">
      <v-card class="text-end px-4 pb-4">
        <v-btn icon @click="dialog = false" class="ml-auto mr-n4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-img src="~/assets/img/invoice.png" contain/>
      </v-card>
    </v-dialog>
    <div class="fixedBtn">
      <BaseTooltip v-if="edit" :tooltip="localStorage.translations.pages.common['buttons']['sohranit']">
        <BaseButton
          :disabled="data.finSystem === 'manual'
            ? !navigationGuardianActive
            : !(validForm && navigationGuardianActive)"
          @click="onSave"
          round icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip v-else :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']">
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit"/>
      </BaseTooltip>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BaseButton from "components/base/BaseButton";
import BaseCard from "components/base/BaseCard.vue";

export default {
  name: "settingCompanyFinancialSystem",
  components: {BaseCard, BaseButton},
  data: () => ({
    key: 0,
    data: {
      finSystem: 'manual',
      groupCode: '',
      groupName: '',
      username: '',
      password: '',
      accountId: '',
      customerId: '',
      netvisorCustomerId: '',
      netvisorPartnerId: '',
      netvisorOrganizationId: '',
      netvisorUserKey: '',
      netvisorPartnerKey: '',
      clientId: '',
      clientSecret: '',
      clientKey: '',
    },
    dialog: false,
    validForm: true,
    showPassword: false,
    showNetvisorUserKey: false,
    showNetvisorPartnerKey: false,
    showProcounterClientSecret: false,
    showProcounterClientKey: false,
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    t() {
      return this.localStorage.translations.pages['setting-setting_company'].all
    },
    finSystemList() {
      return [
        {name: this.t['fin-system-manual'], id: 'manual'},
        {name: 'Heeros', id: 'heeros'},
        {name: 'Netvisor', id: 'netvisor'},
        {name: 'Procountor', id: 'procountor'},
      ]
    },
    edit() {
      return this.$route.name === 'SettingCompanyFinancialSystemEdit'
    },
    presetBaseInput() {
      return {
        view: !this.edit,
        rules: ['required'],
      }
    },
    notification() {
      return this.localStorage.translations.pages.common.notifications
    },
  },
  watch: {
    data: {
      handler() {
        this.onCheckChange({overwrite: false})
        let temp = []
        for (let i in this.data) {
         temp.push(this.data[i].length > 0)
        }
        //this.validForm = temp.every(e => {return e !== false})
      },
      deep: true
    },
    '$route.name'() {
      this.onCheckChange({overwrite: true})
    }
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions('commonConfig', ['onCommonConfigSettings', 'onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions(['onCompaniesConfig']),
    onCheckChange({overwrite}) {
      this.onNavigationGuardianCheck({
        data: {
          companyFinancialSettings: this.data
        },
        overwrite,
      })
    },
    async getData() {
      await this.onCommonConfigSettings({name: 'account_settings'})
        .then(res => {
          this.data.finSystem = res.data.fin_system || 'manual'
          this.data.groupCode = res.data['extra_work_group_code'] || ''
          this.data.groupName = res.data['extra_work_group_name'] || ''
          this.data.username = res.data['heeros_username'] || ''
          this.data.password = res.data['heeros_password'] || ''
          this.data.accountId = res.data['heeros_account_id'] || ''
          this.data.customerId = res.data['heeros_customer_id'] || ''
          this.data.netvisorCustomerId = res.data['netvisor_customer_id'] || ''
          this.data.netvisorPartnerId = res.data['netvisor_partner_id'] || ''
          this.data.netvisorOrganizationId = res.data['netvisor_organization_id'] || ''
          this.data.netvisorUserKey = res.data['netvisor_user_key'] || ''
          this.data.netvisorPartnerKey = res.data['netvisor_partner_key'] || ''
          this.data.clientId = res.data['procountor_client_id'] || ''
          this.data.clientSecret = res.data['procountor_client_secret'] || ''
          this.data.clientKey = res.data['procountor_api_key'] || ''
          this.key++
          this.onCheckChange({overwrite: true})
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.notification['oshibka'], IsError: false},
            {root: true},
          )
        })
    },
    onEdit() {
      this.$router.push({name: this.edit ? 'SettingCompanyFinancialSystem' : 'SettingCompanyFinancialSystemEdit'})
    },
    async onSave() {
      let temp = {}
      let valid = true
      if (this.data.finSystem !== 'manual') {
        if (this.data.finSystem === 'heeros') {
          if (this.$refs.heeros.validate()) {
            temp.heeros_username = this.data.username
            temp.heeros_password = this.data.password
            temp.heeros_account_id = this.data.accountId
            temp.heeros_customer_id = this.data.customerId
          } else valid = false
        }
        if (this.data.finSystem === 'netvisor') {
          if (this.$refs.netvisor.validate()) {
            temp.netvisor_customer_id = this.data.netvisorCustomerId
            temp.netvisor_partner_id = this.data.netvisorPartnerId
            temp.netvisor_organization_id = this.data.netvisorOrganizationId
            temp.netvisor_user_key = this.data.netvisorUserKey
            temp.netvisor_partner_key = this.data.netvisorPartnerKey
          } else valid = false
        }
      }
      if (this.$refs.form.validate()) {
        temp.extra_work_group_code = this.data.groupCode
        temp.extra_work_group_name = this.data.groupName
      } else valid = false
      temp.fin_system = this.data.finSystem
      if (valid) {
        await this.onCommonConfigSettingsUpdate({name: 'account_settings', data: temp})
          .then(() => {
            this.onCompaniesConfig()
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['izmeneniya-uspeshno-sohraneny'], IsError: false},
              {root: true},
            )
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {message: this.notification['oshibka'], IsError: false},
              {root: true},
            )
          })
        this.onCheckChange({overwrite: true})
        this.onEdit()
      }
    },
  }
}
</script>

<style scoped lang="scss">
.d-flex {
  gap: 12px;
}

.border {
  border: 1px solid rgba(#277faf, 0.1);
  border-radius: 4px;
}

.gap {
  gap: 20px;
}
</style>